<template>
  <div>
    <div
      v-if="loadingContacts"
      class="text-center">
      <coozzy-spinner />
    </div>
    <template v-else>
      <div
        v-for="(object, index) in selectedObjectToProcess"
        :key="object.id">
        <enter-termination-review-object
          v-if="tenancyByObjectId[object.id]"
          ref="enter-termination-details-tenant-items"
          :object="object"
          :tenancy="tenancyByObjectId[object.id]"
          :contacts-for-tenant="contactsByObjectId[object.id] || []"
          :can-copy-data="index === 0 && selectedObjectToProcess.length > 1"
          :default-select-contact="listContacts"
          @selected-entries-review="itemSelectedReview"
          @copy-data-from-first-review="copyDataFromFirstReview" />
        <hr v-if="index !== selectedObjectToProcess.length - 1">
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import ContactApi from '@/misc/apis/ContactApi'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner'
import EnterTerminationReviewObject from '@/enterTermination/component/EnterTerminationReviewObject'
import { resolveLastTenancy } from '@/misc/utils/tenancyUtils'

export default {
  name: 'EnterTerminationReview',
  components: {
    CoozzySpinner,
    EnterTerminationReviewObject
  },
  props: {
    selectedObjectToProcess: {
      type: Array,
      required: true
    },
    sameTenanciesByObject: {
      type: Array,
      required: true
    },
    tenancyId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      selectedEntriesReview: [],
      listContacts: [],
      loadingContacts: true,
      tenancyByObjectId: {},
      contactsByObjectId: {}
    }
  },
  mounted() {
    this.loadBatchedContacts()
  },
  methods: {
    resolveTenancyForObject(objectId) {
      const forObject = this.sameTenanciesByObject.filter(t => t.objectId === objectId)
      return resolveLastTenancy(forObject, this.tenancyId)
    },
    loadBatchedContacts() {
      this.loadingContacts = true
      const tenancyByObjectId = {}
      const allContactIds = new Set()

      for (const object of this.selectedObjectToProcess) {
        const tenancy = this.resolveTenancyForObject(object.id)
        if (!tenancy) {
          continue
        }
        tenancyByObjectId[object.id] = tenancy
        for (const id of (tenancy.tenant?.contactIds || [])) {
          if (id) {
            allContactIds.add(id)
          }
        }
        for (const id of (tenancy.tenant?.guarantorContactIds || [])) {
          if (id) {
            allContactIds.add(id)
          }
        }
      }

      this.tenancyByObjectId = tenancyByObjectId

      if (allContactIds.size === 0) {
        this.contactsByObjectId = {}
        this.loadingContacts = false
        return
      }

      ContactApi.contactResolve([...allContactIds])
        .then(response => {
          const byId = {}
          response.persons.concat(response.companies).forEach(contact => {
            byId[contact.id] = contact
          })

          const contactsByObjectId = {}
          for (const object of this.selectedObjectToProcess) {
            const tenancy = tenancyByObjectId[object.id]
            if (!tenancy) {
              contactsByObjectId[object.id] = []
              continue
            }
            const list = []
            for (const id of (tenancy.tenant?.contactIds || [])) {
              const contact = byId[id]
              if (contact) {
                list.push({
                  ...contact,
                  typeInAddingTenancyProcess: contact.typeInAddingTenancyProcess || 'TENANT'
                })
              }
            }
            for (const id of (tenancy.tenant?.guarantorContactIds || [])) {
              const contact = byId[id]
              if (contact) {
                list.push({
                  ...contact,
                  typeInAddingTenancyProcess: 'GUARANTORCONTACT'
                })
              }
            }
            contactsByObjectId[object.id] = list
          }
          this.contactsByObjectId = contactsByObjectId
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.contacts'), { type: 'error' })
        })
        .finally(() => {
          this.loadingContacts = false
        })
    },
    itemSelectedReview(status, objectId) {
      this.selectedEntriesReview[objectId] = status
      this.$emit('selected-entries-review', this.selectedEntriesReview)
    },
    copyDataFromFirstReview(objectId, contacts) {
      this.listContacts = contacts
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
